import { useTranslation } from 'react-i18next';
import { KoobButton, KoobEmptyState } from '@koob/ui';
import { switchActingOrganization } from '@koob/utils';
import { useApp } from 'hooks';
import { Container } from 'ui';

/** The choice among the group's organizations; picking one switches the
 * app's organization picker (and reloads). */
export const ActingOrganizationChoice = () => {
  const { t } = useTranslation();
  const { user, currentOrganization } = useApp();
  const organizations = (user?.organizations ?? []).filter(
    ({ parentId }) =>
      String(parentId) === String(currentOrganization?.organizationId),
  );

  return (
    <KoobEmptyState
      icon={<i className="fa-light fa-buildings text-2xl" />}
      title={t('misc:organizationRequiredTitle')}
      description={t('misc:organizationRequiredPage')}
    >
      <div className="flex flex-wrap justify-center gap-2">
        {organizations.map(({ organizationId, displayName }) => (
          <KoobButton
            key={organizationId}
            variant="secondary"
            onClick={() => switchActingOrganization(organizationId)}
          >
            {displayName}
          </KoobButton>
        ))}
      </div>
    </KoobEmptyState>
  );
};

// KD-3735: for pages that only make sense for one organization (a DMC's
// distribution, editors, creation flows…). In the group view ("<group>
// (Group)") the page is replaced by the choice among its organizations.
const RequireActingOrganization = ({ children }) => {
  const { currentOrganization } = useApp();

  if (!currentOrganization?.isGroup) {
    return children;
  }

  return (
    <Container>
      <ActingOrganizationChoice />
    </Container>
  );
};

export default RequireActingOrganization;
